import React from 'react';
import styled from 'styled-components';

const Position = styled.span`
  position: absolute;
  top: 5px;
  right: 3px;
`;

const Circle = styled.circle`
  stroke-dasharray: 480px, 480px;
  stroke-dashoffset: 960px;
  -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
  animation: checkmark-circle 0.6s ease-in-out backwards;
  @keyframes checkmark-circle {
    0% {
      stroke-dashoffset: 480px;
    }
    100% {
      stroke-dashoffset: 960px;
    }
  }
`;

const ColoredCircle = styled(Circle)`
  stroke-dasharray: 480px, 480px;
  stroke-dashoffset: 960px;
  -webkit-animation: colored-circle 0.6s ease-in-out 0.7s backwards;
  animation: colored-circle 0.6s ease-in-out 0.7s backwards;
  @keyframes colored-circle {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const Polyline = styled.polyline`
  stroke-dasharray: 100px, 100px;
  stroke-dashoffset: 200px;
  -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
  animation: checkmark 0.25s ease-in-out 0.7s backwards @keyframes checkmark {
    0% {
      stroke-dashoffset: 100px;
    }
    100% {
      stroke-dashoffset: 0px;
    }
  }
`;

const Wrong = ({ style }) => (
  <Position style={style}>
    <svg width="30px" height="30px">
      <g fill="none" stroke="#dc3545" strokeWidth="2">
        <Circle cx="15" cy="15" r="10" />
        <ColoredCircle id="colored" fill="#dc3545" cx="15" cy="15" r="10" />
        <Polyline stroke="#fff" points="10,15 20,15" />
      </g>
    </svg>
  </Position>
);

export default Wrong;
